"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("../js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { className: "spectrum-UIIcon-ChevronRightLarge" },
      _react2.default.createElement("path", { d: "M11.5 8a1.236 1.236 0 0 0-.386-.9L4.128.36A1.248 1.248 0 1 0 2.4 2.157L8.45 8l-6.058 5.841a1.248 1.248 0 1 0 1.733 1.8L11.117 8.9A1.246 1.246 0 0 0 11.5 8z", className: "spectrum-UIIcon--medium" }),
      _react2.default.createElement("path", { d: "M15 10a1.24 1.24 0 0 0-.381-.894L5.632.364a1.249 1.249 0 1 0-1.741 1.791L11.957 10l-8.069 7.851a1.245 1.245 0 0 0 .872 2.139 1.235 1.235 0 0 0 .869-.348l8.992-8.742A1.243 1.243 0 0 0 15 10z", className: "spectrum-UIIcon--large" })
    )
  );
};

WrappedIcon.displayName = 'ChevronRightLarge';
exports.default = WrappedIcon;

